<template>
  <el-drawer
      title="模型列表"
      direction="rtl"
      @open="init"
      @close="closeDrawer"
      :visible.sync="visible"
      :with-header="false"
      :destroy-on-close="true"
      size="60%">
    <el-card class="box-card" shadow="never" style="border-bottom: none;height: 100vh;overflow-y: scroll">
      <el-divider class="margin-bottom-15 margin-top-10"></el-divider>

      <el-table class="list-table" :data="modelList" border :stripe="true" style="width: 100%"
                :header-cell-style="{ background: '#eef1f6', color: '#606266' }">
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="模型名称" prop="name"></el-table-column>
        <el-table-column fixed="right" label="操作" width="130">
          <template slot-scope="scope">
            <el-button type="text" @click.prevent="toEditQue(scope.row)" size="small"><i class="fa fa-edit"></i> 编辑</el-button>
            <el-button type="text" @click.prevent="deleteQue(scope.row.id)" size="small"><i class="fa fa-trash"></i> 删除</el-button>
          </template>
        </el-table-column>
      </el-table>

    </el-card>
  </el-drawer>
</template>

<script>
import { fetchList,remove } from '@/api/rep/model'
import QuestionSave from '../QuestionSave'
import { mapGetters } from "vuex";

export default {
  name: 'question-list',
  props: {
    postId:null,
    visible:false
  },
  computed: {
    ...mapGetters(['user', 'company'])
  },
  components: {
    QuestionSave
  },
  data: function() {
    return {
      addQuestionVisible:false,
      question: { },
      questionList: [],
      modelList:[],
    }
  },
  methods: {
    init(){
      this.fetchData()
    },
    fetchData() {
      fetchList(this.company.id).then(resp => {
        this.modelList= resp.data.result
        this.modelList.map(x =>{
          x.contents = JSON.parse(x.contents)
          x.contents = x.contents.map(x=>{return x.name})
        })
      })
    },
    closeDrawer(){
      this.$emit('done')
    },
  }

}
</script>
<style lang="scss" scoped>
.option-table{
  width: 98%;
  margin:5px auto;
  border-left: none;
  border-right: none;
  th{
    background-color: #f7f7f7;
  }
}
</style>
